import { MoreShapes } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P } from "apparatus/library/common";
import { BasicShapes } from "apparatus/library/shapes/common";
import "ext/color";
import { Group } from "paper";
export class Cylinder {
    constructor() {
        this.drivers = [
            {
                type: "rectangle",
                minX: 6, maxX: 250,
                minY: 8, maxY: 300,
                toAppearance: (f, p) => f({
                    diameter: p.x * 2,
                    height: p.y * 2
                }),
                fromAppearance: a => P(a.diameter / 2, a.height / 2),
                scale: 1.0,
            }
        ];
    }
    render(appearance) {
        const { diameter, height, stroke, style, strokeThickness, shading } = appearance;
        const { body, top, outline } = MoreShapes.cylinder3d({ diameter, height });
        const graphic = new Group([body, top]);
        if (style == "full" || style == "stroke-only") {
            outline.withStroke(strokeThickness, stroke);
            graphic.addChild(outline);
        }
        else {
            outline.remove();
        }
        const fillColor = BasicShapes.fillColor(appearance).color();
        if (shading == "3d") {
            top.withGradientFill("right", Gradients.simple(fillColor.ladd(10)));
            body.withGradientFill("left", Gradients.cylinder(fillColor, 3));
        }
        else {
            top.fillColor = fillColor.ladd(10).string();
            body.withFill(fillColor.string());
        }
        return {
            graphic: graphic,
            hitShape: graphic.rectHitShape(),
        };
    }
}
Cylinder.properties = {
    label: "Cylinder",
    defaultAppearance: Object.assign(Object.assign({}, BasicShapes.defaultAppearance), { diameter: 120, height: 150, shading: "flat" }),
    appearanceSpecs: [
        ...BasicShapes.specs,
        BasicShapes.header,
        {
            spec: "toggle-buttons", key: "shading", label: "Shading", size: "text",
            options: [
                { value: "flat", label: "Flat" },
                { value: "3d", label: "3D", tier: "boost" },
            ],
            allowSelectingTierLockedOptions: true,
        }
    ],
    isBoostRequired: a => a.shading === "3d"
};
